const constructFile = file => file ? `data:${file.mime};base64,${file.base64}` : undefined;

export default constructFile;